import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/marketing/Navbar";
import Footer from "../components/marketing/Footer";
import { TESTIMONIALS, LOGOS } from "../mock";

const STORIES = [
  { company: "Aurora Rail", stat: "5h saved per week on invoicing", quote: TESTIMONIALS[0].quote },
  { company: "Field & Form", stat: "22% more billable time captured", quote: TESTIMONIALS[1].quote },
  { company: "Cedar Advisory", stat: "Cut month-end from 2 days to 3 hours", quote: TESTIMONIALS[2].quote },
];

export default function Customers() {
  return (
    <div className="min-h-screen bg-cream">
      <Navbar />
      <section className="max-w-7xl mx-auto px-5 md:px-8 pt-16 pb-10">
        <div className="text-sm text-coral font-semibold uppercase tracking-wide">Customers</div>
        <h1 className="font-display text-5xl md:text-6xl mt-3 max-w-3xl">Loved by teams who bill for their expertise.</h1>
      </section>
      <section className="max-w-7xl mx-auto px-5 md:px-8 pb-8 flex flex-wrap gap-x-10 gap-y-3 opacity-80">
        {LOGOS.map((l) => <div key={l} className="font-display text-lg text-forest/70">{l}</div>)}
      </section>
      <section className="max-w-7xl mx-auto px-5 md:px-8 pb-20 grid md:grid-cols-3 gap-6">
        {STORIES.map((s) => (
          <div key={s.company} className="bg-white rounded-xl border border-cream p-6">
            <div className="font-display text-3xl text-coral">{s.stat.split(" ")[0]}</div>
            <div className="text-sm mt-1 text-[#3f4a44]">{s.stat.substring(s.stat.indexOf(" ") + 1)}</div>
            <p className="mt-5 text-sm">“{s.quote}”</p>
            <div className="mt-4 text-xs text-[#6a736f]">— {s.company}</div>
          </div>
        ))}
      </section>
      <section className="max-w-7xl mx-auto px-5 md:px-8 pb-20">
        <div className="rounded-2xl bg-forest text-white p-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div>
            <h3 className="font-display text-3xl">Join the teams delivering better projects with Full Bench.</h3>
            <p className="mt-2 text-white/80">Free for 30 days. No credit card required.</p>
          </div>
          <Link to="/signup" className="btn-coral px-6 py-3 rounded-md text-sm font-medium">Try Full Bench free</Link>
        </div>
      </section>
      <Footer />
    </div>
  );
}
